import { IOpenModalAction } from "../interfaces/modal.interface";

export function openModal(id: string, modalData = {}): IOpenModalAction {
  return {
    type: "OPEN_MODAL",
    data: { id, modalData },
  };
}
